import { CustomTabList, Heading } from "@/components";
import { Card } from "@/components/ui";
import { capitalize } from "@/lib/utils";
import { InventoryInfo, LabInfo } from "@/pages/Finance/School/Add/TabsData";
import { routes } from "@/routes/utils";
import { Tabs, TabsContent } from "@radix-ui/react-tabs";
import { tabs as defaultTabs } from "./consts";
import { InstallmentSchedule, LabInventoryInfo, SchoolInfo } from "./TabsData";
import useAdd from "./useAdd";

const Add = () => {
  const { action, currentTab, onTabChange, onNextClick } = useAdd();

  // 🧠 Modify tab title dynamically based on action
  // 🧠 Modify tab title dynamically & filter Inventory tab for edit mode only
const tabs = defaultTabs
  .filter((tab) => {
    // Remove Inventory tab (value "4") when not editing
    if (tab.value === "4" && action !== routes.edit) return false;
    return true;
  })
  .map((tab) =>
    tab.value === "3" && action === routes.edit
      ? { ...tab, title: "Lab" }
      : tab
  );


  return (
    <div className="p-7">
      <Heading
        title={
          <span>
            <span className="text-g-300">School Onboarding</span>
            <span className="mx-3">|</span>
            <span>{capitalize(action || "")} School</span>
          </span>
        }
      />

      <Card className="py-5 pt-0 mt-6 shadow-none">
        <Tabs
          defaultValue="1"
          className="mt-6"
          value={currentTab}
          onValueChange={onTabChange}
        >
          {/* 🔄 Use modified tabs */}
          <CustomTabList
            tabs={tabs}
            className="mx-5"
            currentTab={currentTab}
            action={action}
          />

          {/* Tab 1 */}
          <TabsContent value="1" className="px-0">
            <SchoolInfo onNextClick={onNextClick} />
          </TabsContent>

          {/* Tab 2 */}
          <TabsContent value="2" className="px-0">
            <InstallmentSchedule onNextClick={onNextClick} />
          </TabsContent>

          {/* Tab 3 → Conditional Component */}
          <TabsContent value="3" className="px-0">
            <div style={{ display: action === routes.edit ? "block" : "none" }}>
              <LabInfo />
            </div>
            <div style={{ display: action !== routes.edit ? "block" : "none" }}>
              <LabInventoryInfo />
            </div>
          </TabsContent>

          {/* Tab 4 → Show only in edit mode */}
          {action === routes.edit && (
            <TabsContent value="4" className="px-0">
              <InventoryInfo />
            </TabsContent>
          )}
        </Tabs>
      </Card>
    </div>
  );
};

export default Add;
